import { amountToPriceString } from '@caterdesk/utils--money'
import { Divider, Stack, Typography } from '@mui/material'
import type React from 'react'
import { useTranslation } from 'react-i18next'

export type Props = {
  currency: string | null
  deliveryFee?: number | null
  minOrderFee?: number | null
  minNoticePeriod?: number | null
}

const SupplierDeliverySummary: React.FC<Props> = ({
  currency,
  deliveryFee,
  minOrderFee,
  minNoticePeriod,
}) => {
  const { t } = useTranslation()

  const normalizedDeliveryFee = typeof deliveryFee === 'number' ? deliveryFee : null
  const normalizedMinOrder = typeof minOrderFee === 'number' ? minOrderFee : null
  const normalizedNotice = typeof minNoticePeriod === 'number' ? minNoticePeriod : null

  const deliveryAmount =
    normalizedDeliveryFee === null
      ? '--'
      : normalizedDeliveryFee === 0
        ? 'Free'
        : amountToPriceString(currency || 'GBP', normalizedDeliveryFee, true)

  const minimumAmount =
    normalizedMinOrder === null
      ? '--'
      : normalizedMinOrder === 0
        ? 'No'
        : amountToPriceString(currency || 'GBP', normalizedMinOrder, true)

  const noticeLabel = normalizedNotice === 1 ? t('marketplace:hour') : t('marketplace:hours')
  const leadTimeAmount = normalizedNotice === null ? '--' : `${normalizedNotice} ${noticeLabel}`

  const deliverySummaryData = [
    {
      label: t('marketplace:delivery'),
      amount: deliveryAmount,
    },
    {
      label: t('marketplace:minimum'),
      amount: minimumAmount,
    },
    {
      label: t('marketplace:leadTime'),
      amount: leadTimeAmount,
    },
  ]

  return (
    <Stack flexDirection="column" justifyContent="space-evenly" mb={1}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        divider={
          <Divider
            flexItem
            orientation="vertical"
            sx={{ borderColor: 'text.muted', opacity: 0.4 }}
          />
        }
      >
        {deliverySummaryData.map((item) => (
          <Typography variant="body3" color="text.muted" key={item.label}>
            <Typography component="span" fontWeight={600} variant="body3" color="text.muted">
              {item.amount}
            </Typography>{' '}
            {item.label}
          </Typography>
        ))}
      </Stack>
    </Stack>
  )
}

export default SupplierDeliverySummary
